<app-sidebar></app-sidebar>

<div class="map-container">
    <app-map [mode]="'route history'" *ngIf="routes()" [routes]="routes()"></app-map>
</div>

<div class="altitude-graph-center">
    <app-altitude-and-speed-graph *ngIf="routes()" [routes]="routes()"></app-altitude-and-speed-graph>
</div>